import { Input } from "design-react-kit";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import UploadFile from "../../Components/UploadFile";
import StateTranslate from "../../Components/StateTranslate";
import LabelsLoader from "../../Utility/labelsLoader";
import AllegatiComponent from "../../Components/AllegatiComponent";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditAnnouncement(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  // const [rangesList, setRangesList] = useState([]);
  const [arrRanges1, setArrRanges1] = useState();
  const [arrRangesTemp1, setArrRangesTemp1] = useState([]);
  const [arrRanges2, setArrRanges2] = useState([]);
  const [arrRangesTemp2, setArrRangesTemp2] = useState([]);
  const [arrRangesFilter1, setArrRangesFilter1] = useState();
  const [validation, setValidation] = useState(false);

  const labels = LabelsLoader();

  const [stati, setStati] = useState([
    { label: undefined, label_it: "", value: "" },
    { label: "CREATE", label_it: "CREATO", value: "0" },
    { label: "OPEN", label_it: "APERTO", value: "1" },
    { label: "CLOSED", label_it: "CHIUSO", value: "2" },
    { label: "ARCHIVED", label_it: "ARCHIVIATO", value: "3" },
  ]);

  const [temp, setTemp] = useState({
    id: null,
    name: null,
    cost: null,
    serviceId: null,
    bandsId: null,
    state: null,
    maxUsers: null,
    hasCoupon: false,
    hasPayment: false,
    hasMoney: false,
    hasPresenze: false,
    externalId: null,
  });

  const [statoTemp, setStatoTemp] = useState();

  const [loading, setLoading] = useState(false);
  const [session, setSession] = useState({});
  const [loadedRanges, setLoadedRanges] = useState(false);
  const [filterRange, setFilterRange] = useState();
  const [versioneServizio, setVersioneServizio] = useState([]);

  var versionePagamento = labels.versione;
  const [errorMessage, setErrorMessage] = useState(false);

  const handleChangeCheckbox = (property, value) => {
    setSession({ ...session, [property]: value });
  };

  let query = useQuery();

  const announcementId = query.get("sessionId");

  useEffect(() => {
    if (apiToken) {
      setLoading(true); // Inizia a caricare

      if (query.get("sessionId")) {
        Repo.getSessionById(apiToken, announcementId)
          .then((response) => {
            setSession(response.data);
          })
          .catch((error) => console.error(error))
          .finally(() => setLoading(false));
      } else setLoading(false);

      Repo.getRangesList(apiToken)
        .then((response) => {
          setArrRanges1(response.data);
          setArrRangesFilter1(response.data);
          setLoadedRanges(true);
        })
        .catch((error) => console.error(error));

      Repo.getServices(apiToken)
        .then((response) => {
          setServicesList(response.data);
        })
        .catch((error) => console.error(error))
        .finally(() => setLoading(false));

      Repo.getSelectVersioneServizio(apiToken)
        .then((response) => {
          setVersioneServizio(response.data);
        })
        .catch((error) =>
          console.error("Errore getSelectVersioneServizio:", error),
        );

      Repo.getListaServizi(apiToken)
        .then((response) => {
          setServizi(response.data);
        })
        .catch((error) => console.error(error));
    }
  }, []);

  useEffect(() => {
    if (session.bands?.length && arrRanges1) {
      setArrRanges2(session.bands);
      const rangesInit = arrRanges1.filter(
        (obj) => !session.bands.some((obj2) => obj.id === obj2.id),
      );
      setArrRanges1(rangesInit);
    }
  }, [session, loadedRanges]);

  const checkSession = () => {
    setValidation(true);
    let passedValidation = true;

    if (session.serviceId == null && session.service?.id == null)
      passedValidation = false;

    if (session.name == null) passedValidation = false;

    setTemp({
      ...temp,
      id: session.id,
      name: session.name,
      codAccertamento: session.codAccertamento,
      codCapitolo: session.codCapitolo,
      nomeMyPay: session.nomeMyPay,
      cost: session.cost,
      bandsId: arrRanges2.map((x) => x.id),
      state: parseInt(stati.find((o) => o.label === session.state)?.value),
      hasCoupon: session.hasCoupon,
      maxUsers: session.maxUsers,
      hasMoney: session.hasMoney,
      hasPayment: session.hasPayment,
      hasPresenze: session.hasPresenze,
      externalId: session.externalId,
      anno: session.anno,
      serviceId: session.service?.id ?? session.serviceId,
    });

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const postUpdateSession = () => {
    Repo.postUpdateSession(apiToken, JSON.stringify(temp))
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder +
            "/lista_interventi/dettaglio_intervento?id=" +
            query.get("sessionId");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeRange = (event, percent, fixedcost) => {
    if (event) {
      let name = event.target.name;
      let id = event.target.id;
      let checked = event.target.checked;
      let value = event.target.value;

      // Trova l'oggetto originale dal giusto array
      let original = null;
      if (name === "checkBox1") {
        original = arrRanges1.find((item) => item.id === id);
      } else if (name === "checkBox2") {
        original = arrRanges2.find((item) => item.id === id);
      }

      switch (name) {
        case "checkBox1":
          if (checked && original) {
            setArrRangesTemp1((prevState) => [...prevState, { ...original }]);
          } else {
            var arr = arrRangesTemp1.filter((item) => item.id !== id);
            setArrRangesTemp1(arr);
          }
          break;
        case "checkBox2":
          if (checked && original) {
            setArrRangesTemp2((prevState) => [...prevState, { ...original }]);
          } else {
            var arr = arrRangesTemp2.filter((item) => item.id !== id);
            setArrRangesTemp2(arr);
          }
          break;
        default:
          break;
      }
    }
  };

  const transferRange = (bool) => {
    if (bool) {
      setArrRanges2(arrRanges2.concat(arrRangesTemp1));

      var arr = arrRanges1.filter(function (obj) {
        return !arrRangesTemp1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp1.filter(function (obj) {
        return !arrRanges1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges1(result);
      setArrRangesTemp1([]);
    } else {
      setArrRanges1(arrRanges1.concat(arrRangesTemp2));

      var arr = arrRanges2.filter(function (obj) {
        return !arrRangesTemp2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp2.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges2(result);
      setArrRangesTemp2([]);
    }
  };

  useEffect(() => {
    if (filterRange && arrRanges1) {
      var arr = arrRanges1.filter(function (obj) {
        return obj.name?.toLowerCase().includes(filterRange?.toLowerCase());
      });
      setArrRanges1(arr);
    } else if (arrRangesFilter1) {
      var arr2 = arrRangesFilter1.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
      setArrRanges1(arr2);
    }
  }, [filterRange]);

  const transferBlock = () => {
    return (
      <>
        <div className="row mt-4">
          <div className="col-xs-12 col-md-5">
            <Input
              id="filterRange"
              label="Ricerca Fasce Isee"
              type="text"
              name="filterRange"
              value={filterRange ? filterRange : ""}
              onChange={(e) => setFilterRange(e.target.value)}
            />
          </div>
        </div>
        <div className="it-transfer-block">
          <div className="row">
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper source">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1">
                      <span>FASCE ISEE DISPONIBILI</span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges1 &&
                      arrRanges1.length > 0 &&
                      arrRanges1.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox1"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp1 &&
                            arrRangesTemp1.length > 0 &&
                            arrRangesTemp1.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              {x.name} ({x.min} - {x.max} €)
                              <br />
                              <div className="ml-4">
                                Costo: <b>{x.costoFinale}</b>{" "}
                                {x.dataVigore && (
                                  <>
                                    da <b>{x.dataVigore}</b>
                                  </>
                                )}
                              </div>
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Button */}
            <div className="col-xs-12 col-md-2">
              <div className="it-transfer-buttons">
                {arrRangesTemp1 && arrRangesTemp1.length > 0 ? (
                  <>
                    <button
                      className="transfer"
                      style={{
                        border: "1px solid #06c",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      onClick={() => transferRange(true)}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                ) : (
                  <>
                    <button
                      className="transfer"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "50%",
                        cursor: "not-allowed",
                      }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                )}

                {arrRangesTemp2 && arrRangesTemp2.length > 0 ? (
                  <>
                    <button
                      style={{
                        border: "1px solid #06c",
                        borderRadius: "50%",
                        cursor: "pointer !important",
                      }}
                      className="backtransfer mt-2"
                      href="#"
                      aria-label="Sposta indietro"
                      onClick={(e) => {
                        e.preventDefault();
                        transferRange(false);
                      }}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow left</span>
                  </>
                ) : (
                  <>
                    <button
                      className="backtransfer mt-2"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "50%",
                        cursor: "not-allowed",
                      }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper target">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1b">
                      <span>
                        <span>FASCE ISEE SELEZIONATE</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges2 &&
                      arrRanges2.length > 0 &&
                      arrRanges2.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox2"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp2 &&
                            arrRangesTemp2.length > 0 &&
                            arrRangesTemp2.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              {x.name} ({x.min} - {x.max} €)
                              <br />
                              <div className="ml-4">
                                Costo: <b>{x.costoFinale}</b>{" "}
                                {x.dataVigore && (
                                  <>
                                    da <b>{x.dataVigore}</b>
                                  </>
                                )}
                              </div>
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <h1>Modifica intervento</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Modifica i dati relativi all'intervento</p>
      </div>
      <div className="col-lg-12">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after roundedCustom">
            <div className="card-body p-5">
              <div className="row">
                <div className="col-lg-10">
                  <Input
                    id="title"
                    label="Titolo*"
                    type="text"
                    name="title"
                    value={session.name || session.name || ""}
                    onChange={(e) =>
                      setSession({ ...session, name: e.target.value })
                    }
                    {...(validation &&
                      !session.name && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-2 ">
                  <Input
                    id="anno"
                    label="Anno"
                    type="text"
                    value={session.anno || ""}
                    maxLength={4}
                    onChange={(e) => {
                      // Accetta solo cifre e massimo 4 caratteri
                      const val = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 4);
                      setSession({
                        ...session,
                        anno: val ? parseInt(val, 10) : "",
                      });
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Servizio"
                    clearText="Annulla"
                    defaultMenuIsOpen={false}
                    icon={false}
                    name="servizio"
                    id="servizio"
                    options={servicesList.map((s) => ({
                      value: s.id,
                      label: s.name,
                    }))}
                    onChange={(e) => {
                      setSession({
                        ...session,
                        serviceId: e ? e.value : null,
                        service: e ? { id: e.value, name: e.label } : null,
                      });
                    }}
                    isClearable
                    isSearchable
                    value={session.serviceId || ""}
                    placeholder={
                      session.service
                        ? session.service.name
                        : "Seleziona categoria*"
                    }
                  />
                  {validation && !session.service.id ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Stato intervento"
                    defaultMenuIsOpen={false}
                    required
                    icon={false}
                    name="state"
                    id="state"
                    options={stati}
                    onChange={(e) => {
                      setStatoTemp(e ? e.label : null);
                      setSession({ ...session, state: e.label });
                    }}
                    value={
                      session.state
                        ? stati.find((o) => o.label === session.state) || null
                        : null
                    }
                    placeholder={
                      session.state
                        ? session.state
                        : stati.find((o) => o.label === undefined)?.label_it ||
                          "Seleziona stato*"
                    }
                    getOptionLabel={(option) => option.label_it || option.label} // Utilizza la label tradotta se disponibile
                    getOptionValue={(option) => option.label_it || option.label} // Utilizza la label tradotta come value
                  />
                </div>
              </div>
              <div className="row mt-4 mb-2">
                <div className="col-lg-4">
                  <Input
                    id="nomeMyPay"
                    label={labels.nomecampo1}
                    type="text"
                    name="nomeMyPay"
                    value={session.nomeMyPay || session.nomeMyPay || ""}
                    onChange={(e) =>
                      setSession({ ...session, nomeMyPay: e.target.value })
                    }
                  />
                </div>

                <div className="bootstrap-select-wrapper col-lg-4">
                  <Select
                    aria-label={labels.versioneServizio}
                    name="externalId"
                    id="externalId"
                    options={[
                      { value: "", label: "Nessun valore" }, // Opzione vuota
                      ...versioneServizio,
                    ]}
                    value={
                      versioneServizio?.find(
                        (option) => option.value === session.externalId,
                      ) || { value: "", label: "Nessun valore" }
                    }
                    onChange={(e) => {
                      setSession({ ...session, externalId: e.value || null });
                    }}
                    placeholder="Seleziona modulo da associare"
                  />
                  {!session.externalId && (
                    <p className="text-muted">Nessun valore associato</p>
                  )}
                </div>

                <div className="col-lg-4">
                  <Input
                    id="externalId"
                    label={labels.versioneServizio}
                    type="text"
                    name="externalId"
                    value={session.externalId || null} // Mostra stringa vuota se il valore è null
                    onChange={(e) => {
                      const value = e.target.value || null; // Imposta null se il campo è vuoto
                      setSession({ ...session, externalId: value });
                    }}
                  />
                </div>

                <div className="form-check col-lg-3 offset-lg-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="hasPayment"
                    name="hasPayment"
                    onChange={(e) =>
                      handleChangeCheckbox("hasPayment", e.target.checked)
                    }
                    checked={session.hasPayment}
                  />
                  <label className="form-check-label" htmlFor="hasPayment">
                    {labels.hasPayment}
                  </label>
                </div>

                <div className="form-check col-lg-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="hasMoney"
                    name="hasMoney"
                    onChange={(e) =>
                      handleChangeCheckbox("hasMoney", e.target.checked)
                    }
                    checked={session.hasMoney}
                  />
                  <label className="form-check-label" htmlFor="hasMoney">
                    {labels.hasMoney}
                  </label>
                </div>
              </div>
              <h6>Fasce ISEE:</h6>
              {transferBlock()}

              {/*inizio allegati*/}

              {announcementId && (
                <AllegatiComponent
                  entityId={announcementId}
                  tipoEntity="Announcement"
                />
              )}

              {/*fine allegati*/}

              <div className="row mt-2">
                <div className="col-lg-12 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => checkSession()}
                    title="Conferma"
                  >
                    Conferma
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modificare intervento"
        body="Confermi di voler modificare l'intervento?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postUpdateSession()}
      ></ModalComponent>
      {loading && <Loader></Loader>}
    </>
  );
}

export default EditAnnouncement;
